import { render, staticRenderFns } from "./MainDialogCard.vue?vue&type=template&id=15d23601&scoped=true"
import script from "./MainDialogCard.vue?vue&type=script&lang=ts"
export * from "./MainDialogCard.vue?vue&type=script&lang=ts"
import style0 from "./MainDialogCard.vue?vue&type=style&index=0&id=15d23601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d23601",
  null
  
)

export default component.exports